import React from "react";
import "./ToolBar.scss";
import { aliflogo } from "../../shared/images/icons";
import { Link } from "react-router-dom";
export const ToolBar = () => {

  return (
    <div className="toolBar">
      <Link to="/">{aliflogo}</Link>
    </div>
  );
};

export default ToolBar;
